<template>
<div class="member-info">
        <div class="member-avatar">
            <img :src="data.memberAvatar">
        </div>
        <div class="member-detail">
            <div class="member-name">{{ data.memberName }}</div>
            <div class="member-department">{{ data.departmentName }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Member",
    props: {
        data: {
            type: Object,
        }
    },
    data() {
        return {

        }
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.member-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;

    .member-avatar {
        width: 37px;
        height: 37px;
        margin: 4px 8px;
        border-radius: 8px;

        img {
            width: 37px;
            height: 37px;
            border-radius: 8px;
        }
    }

    .member-detail {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;

        .member-name {
            color: #323233;
            font-size: 14px;
            font-family: "PingFang SC", sans-serif;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0;
            text-align: left;
        }

        .member-department {
            max-width: 422px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #A2A4B0;
            letter-spacing: 0;
            line-height: 17px;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: keep-all;
        }
    }
}
</style>
